import { render, staticRenderFns } from "./helpOTP.vue?vue&type=template&id=be98b9ac&scoped=true&lang=pug&"
import script from "./helpOTP.vue?vue&type=script&lang=js&"
export * from "./helpOTP.vue?vue&type=script&lang=js&"
import style0 from "./dialogs.scss?vue&type=style&index=0&id=be98b9ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be98b9ac",
  null
  
)

export default component.exports